var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRacon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2078,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 80,
    width: 2079,
    height: 2078
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1260 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 80.0001,
    width: 2079,
    height: 2078,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368.44 440.385 2387.79 214.808 2530.64 214.808 2550.56 440.385 2368.44 440.385ZM2618.85 440.385 2584.71 440.385 2564.22 198.885C2563.08 185.615 2553.4 175 2541.45 175L2377.55 175C2365.6 175 2355.92 185.615 2354.78 198.885L2334.29 440.385 2300.15 440.385 2300.15 480.193 2266 480.193 2266 520 2653 520 2653 480.193 2618.85 480.193 2618.85 440.385Z",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacon);
export default __webpack_public_path__ + "static/media/RACON.89228304396b16bf3a9a74b22948c859.svg";
export { ForwardRef as ReactComponent };